import React from 'react'
import { motion } from "motion/react";
import "./css/paintings.css";
import DivisorDown from "../../components/divisorDown/divisorDown";
import Gallery from '../../components/galery/gallery';
import galleryData from "./json/gallery.json";
import proccesData from "./json/process.json";

const Paintings = () => {
  return (
    <motion.div
      key={"empty"}
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      <div className="col-md-12 d-flex justify-content-center ">
        <div className="color-text-sofia-40-hv">Oil Paintings</div>
      </div>

      <div className="margin-divisor-hv mb-1">
        <DivisorDown
          title="Painting as stillness and structure"
          subtitle="Figurative art is a fundamental pillar of my painting practice. 
          The human figure is one of my main themes, and the artistic elements of  pre-Colombian cultures are also a strong source of inspiration.
          These are some oil paintings I have worked on:"
        />
      </div>

      <div className="margin-botton-gallery-hv mt-5">
        <Gallery images={galleryData}  />
      </div>

      <div className="margin-divisor-hv mb-1">
        <DivisorDown
          title="Artwork Process"
          subtitle="These are some pictures as work-in-progress images showing stages from
          initial sketches on canvas to painting and drawing using different media. While not finished, they offer an idea and  a sense of the development and perception of
          the final artwork."
        />
      </div>

      <div className="margin-botton-gallery-hv mt-5">
        <Gallery images={proccesData} data={false}/>
      </div>

    </motion.div>
    
  )
}

export default Paintings
